export enum CustomerBillerStatus {
  CONFIRMED = 'CONFIRMED',
  ENABLED = 'ENABLED',
  INVALID = 'INVALID',
  MISSING_CONFIGURATION = 'MISSING_CONFIGURATION',
  NO_RECURRING_CONFIGURATION = 'NO_RECURRING_CONFIGURATION',
  NO_SOURCE = 'NO_SOURCE',
  USER_ACTION_NEEDED = 'USER_ACTION_NEEDED',
  VERIFYING = 'VERIFYING',
  FOLLOW_UP_CREDENTIALS_REQUIRED = 'FOLLOW_UP_CREDENTIALS_REQUIRED',
  INVALID_FOLLOW_UP_CREDENTIALS = 'INVALID_FOLLOW_UP_CREDENTIALS',
}
